import { useNavigate } from '@ksyos/router';
import { namedRoutes } from '@frontend/routes';

type RouteName = keyof typeof namedRoutes;

type RouteParams = {
    [Route in RouteName]: { [Param in keyof ExtractRouteParams<(typeof namedRoutes)[Route]['path']>]: string };
};

type ExtractRouteParams<Route extends string> = Route extends `${infer _Start}:${infer Param}/${infer Rest}`
    ? { [param in Param | keyof ExtractRouteParams<`/${Rest}`>]: string }
    : Route extends `${infer _Start}:${infer Param}`
      ? { [param in Param]: string }
      : never;

export function useNavigateTo() {
    const navigate = useNavigate();

    return <Route extends RouteName>(route: RouteName, params: RouteParams[Route]) => {
        const url = generateUrlForRoute(route, params);
        navigate(url);
    };
}

export function generateUrlForRoute<Route extends RouteName>(
    route: RouteName,
    params: RouteParams[Route],
    queryParams?: Record<string, string>
) {
    const path = namedRoutes[route].path;

    let url = path.replace(/:([^/]+)/g, (_, key: keyof RouteParams[Route]) => params[key]);
    if (queryParams) {
        url += '?' + new URLSearchParams(queryParams).toString();
    }

    return url;
}
